import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../inputs/button';
import { Email } from '../links/email';
import { Telephone } from '../links/telephone';
import { ProfilePhoto } from '../profilePhoto/profilePhoto';
import { AutoSizeCard } from './autoSizeCard';

import styles from './userPopoutCard.module.css';

/**
 * @param {Object} props
 * @param {Object} props.data User Data
 * @param {string|null} [props.subtitle=null] Subtitle
 * @param {boolean} [props.showEmail=false] Show Email
 * @param {boolean} [props.showPhone=false] Show Phone
 * @param {boolean} [props.showAuthorizedSystems=false] Show Authorized Systems
 * @param {JSX.Element|null} [props.action=null] Action
 */
export const UserPopoutCard = ({
    data = {},
    subtitle = null,
    action = null,
    showEmail = false,
    showPhone = false,
    showAuthorizedSystems = false,
}) => {

    const navigate = useNavigate();

    const handleClick = () => {
        navigate('/users/' + data.id);
    }

    return <AutoSizeCard
        className={styles.UserCard}
    >
        <div className={styles.Layout}>
            <div className={styles.ProfilePicture}>
                <ProfilePhoto userId={data.id} hasProfilePhoto={data.hasProfilePhoto} />
            </div>

            <div className={styles.Stats}>
                { subtitle && <h3>{subtitle}</h3> }
                <h1>{data.displayName ?? 'None'}</h1>
                { showEmail && data.mail && <Email email={data.mail} /> }
                { showPhone && data.mobilePhone && <Telephone number={data.mobilePhone} /> }
                { showAuthorizedSystems && data.authorizedForSystemCount != null && <h3>{data.authorizedForSystemCount} accessible systems</h3> }
            </div>

            {action != <></> &&
            <div className={styles.Action}>
                {action ? action : <Button disabled={!data.id} onClick={handleClick} className='primary'>View</Button>}
            </div>
            }
        </div>

    </AutoSizeCard>
}